import React from 'react';

export type SearchTeaserProps = {
  id: string;
  highlightedHeadline: React.ReactNode;
  highlightedIntro: React.ReactNode;
  slug: string;
  subline?: string;
  url: string;
  image?: string;
  post_date_timestamp: number;
  headline?: string;
  title: string;
  intro?: string;
  format?: string[];
  topic?: string[];
  date?: string;
  readingTime?: string;
  cta: string;
  content: string;
};

const SearchTeaser = ({
  highlightedHeadline,
  highlightedIntro,
  subline,
  intro,
  headline,
  title,
  image,
  topic,
  date,
  url,
  readingTime,
  cta
}: SearchTeaserProps) => (
  <a href={url} className="search-list__teaser">
    <div className="search-list__teaser-image">
      <img alt="" src={image}></img>
    </div>
    <div className="search-list__teaser-content">
      {subline && (
        <p className="search-list__teaser-subline typo-label font-uppercase">
          {subline}
        </p>
      )}
      <p className="typo-headline-4">
        {headline ? highlightedHeadline : title}
      </p>
      {intro && <p className="typo-copy">{highlightedIntro}</p>}
      {topic && (
        <div className="search-list__teaser-topics">
          {topic.map((item) => (
            <span key={item} className="tag">
              {item}
            </span>
          ))}
        </div>
      )}
    </div>
    <div className="search-list__teaser-meta">
      {(date || readingTime) && (
        <p className="typo-copy search-list__teaser-info">
          {date && readingTime
            ? `${date}, ${readingTime}`
            : date
            ? date
            : readingTime}
        </p>
      )}

      <div className="button search-list__teaser-cta">
        <span className="button__icon">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M7.49581 3L12.575 8.07914L7.49581 13.1583L6.67086 12.3333L10.3417 8.66247L3 8.66248V7.49581L10.3417 7.49581L6.67086 3.82496L7.49581 3Z" />
          </svg>
        </span>
        <span className="button__label">{cta}</span>
      </div>
    </div>
  </a>
);

export default SearchTeaser;
